import { FormField, FormItem, FormMessage } from "@/components/ui/form";
import { cn } from "@/lib/utils";
import { elementExtraAttributesCreateSchema } from "@ept/shared/src/schemas";
import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { z } from "zod";
import { getDesktopColSpan } from "../utils/form-columns";
import InputWrapper from "./InputWrapper";
import CheckboxInput from "./CheckboxInput";
import DatePickerInput from "./DatePickerInput";
import _ from "lodash";
import SelectInput from "./SelectInput";
import { isElementNotEmpty } from "@ept/shared/src/validators";
import { ELEMENT_TYPES } from "@ept/shared";
type Columns = z.infer<typeof elementExtraAttributesCreateSchema>["columns"];
type TableRowInputsProps = {
  columns: Columns;
  elementId: string;
  rowIndex: number;
  disabled?: boolean;
};
const TableRowInputs = ({
  columns,
  elementId,
  rowIndex,
  disabled
}: TableRowInputsProps) => {
  const form = useFormContext();
  return columns?.map(column => {
    const name = `${elementId}.${rowIndex}.${column.id}`;
    switch (column.type) {
      case "DATE":
        return <div className={cn(getDesktopColSpan(column.colWidth), "relative mt-0 xs:col-span-12 tablet:col-span-12")}>
            <DatePickerInput elementId={name} label={column.name} disabled={disabled} />
          </div>;
      case "SELECT":
        return <div className={cn(getDesktopColSpan(column.colWidth), "relative mt-0 xs:col-span-12 tablet:col-span-12")}>
            <FormField control={form.control} name={name} render={({
            field
          }) => <SelectInput elementId={name} placeholder={column.name} disabled={disabled} options={column.options?.map(option => ({
            text: option?.text!,
            value: option?.value!,
            id: option?.id || ""
          })) || []} isElementValid={isElementNotEmpty(field.value, (column.type || "TEXT_BOX") as (typeof ELEMENT_TYPES)[number]) && !_.get(form.formState.errors, name)} />} />
          </div>;
      case "CHECKBOX":
        return <div className={cn(getDesktopColSpan(column.colWidth), "relative mt-0 xs:col-span-12 tablet:col-span-12")}>
            <CheckboxInput disabled={disabled} elementId={name} label={column.name} />
          </div>;
      default:
        return <FormField key={`${column.id}-${rowIndex}`} control={form.control} name={name} render={({
          field
        }) => <FormItem className={cn(getDesktopColSpan(column.colWidth), "relative mt-0 xs:col-span-12 tablet:col-span-12")}>
                <InputWrapper type={column.type === "NUMBER" ? "number" : "text"} {...field} placeholder={column.name} labelText={column.name} disabled={disabled} isElementValid={isElementNotEmpty(field.value, (column.type || "TEXT_BOX") as (typeof ELEMENT_TYPES)[number]) && !_.get(form.formState.errors, name)} />
                <FormMessage />
              </FormItem>} />;
    }
  });
};
export default TableRowInputs;